import React, { Component } from "react";

import { connect } from "react-redux";
import { openModal } from "../../../../store/actions/ModalActions";
import {
  GetInventoryTargetOverallV4,
  GetInventoryTargetAreaV4,
  GetInventoryTargetClusterV4,
} from "../../../../store/actions/reports-v4/inventory_target_actions";
import { Search, AspectRatio } from "@material-ui/icons";
import InventoryTargetFilterView from "../../view_filters/InventoryTarget/InventoryTargetFilterView";
import { DashboardContext } from "../../dashboard_context";
import {
  Button,
  Container,
  Col,
  Row,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";

import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { Toolbar } from "@material-ui/core";
import NoChartData from "../../../../components/extensions/ErrorPageDefaults/NoChartData";
import GraphView from "./GraphView";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import moment from "moment";
import { SetChartInventoryTargetTitle } from "../../../../store/actions/reports/chart_title_actions";
import PieChart from "../../../../components/extensions/PieChartLoader";

const toDate = new Date();
const fromDate = new Date();

fromDate.setMonth(toDate.getMonth() - 12);

class InventoryBarGraph extends Component {
  state = {
    from_month: fromDate.getMonth(),
    from_year: fromDate.getFullYear(),
    to_month: toDate.getMonth(),
    to_year: toDate.getFullYear(),
    isLoading: false,
    toView: "piece",

    new_target_list: null,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({ isLoading: true });

    return this.props
      .GetInventoryTargetOverallV4({
        from_month: this.state.from_month + 1,
        from_year: this.state.from_year,
        to_month: this.state.to_month + 1,
        to_year: this.state.to_year,
      })
      .then((resp) => {
        if (resp.problem === null) {
          this.setState({ new_target_list: resp.data });

          var chartTitle = renderChartTitle(
            moduleNames.inventoryTarget,
            OperationScope.overall,
            moment(
              new Date(this.state.from_year, this.state.from_month)
            ).format("MMMM DD YYYY"),
            moment(new Date(this.state.to_year, this.state.to_month)).format(
              "MMMM DD YYYY"
            )
          );

          this.props.SetChartInventoryTargetTitle(chartTitle);
        }
        this.setState({ isLoading: false });

        return Promise.resolve(resp);
      });
  };

  handleRadioChanged = (e) => {
    this.setState({
      toView: e,
    });
  };
  renderOptions = () => {
    return (
      <Toolbar className="float-right">
        <ToggleButtonGroup
          hidden={this.props.target_list.length === 0}
          onChange={this.handleRadioChanged}
          size="sm"
          name="filterByRadio"
          type="radio"
          value={this.state.toView}
        >
          <ToggleButton size="sm" variant="light" value="piece">
            Piece
          </ToggleButton>
          <ToggleButton size="sm" variant="light" value="principal">
            Principal
          </ToggleButton>
        </ToggleButtonGroup>

        <Button
          variant="outline-secondary"
          className="m-1"
          size="sm"
          onClick={() => {
            this.props.openModal({
              size: "lg",
              custom: false,
              title: "Filter Target Inventory",
              currentComponent: <InventoryTargetFilterView />,
            });
          }}
        >
          <Search />
        </Button>

        <Button
          hidden={this.props.target_list.length === 0}
          variant="outline-secondary"
          className="m-1"
          size="sm"
          onClick={() => {
            this.props.openModal({
              size: "lg",
              custom: true,
              title: "Pawns Target Inventory",
              currentComponent: (
                <GraphView
                  title={this.props.chartTitle}
                  parent_chart={this.chart}
                  target_list={this.props.target_list}
                  toView={this.state.toView}
                />
              ),
            });
          }}
        >
          <AspectRatio />
        </Button>
        <ModuleLocked
          Lock={() => this.context.Lock(moduleNames.inventoryTarget)}
          Unlock={() => this.context.Unlock(moduleNames.inventoryTarget)}
          isLocked={this.context.inventoryTargetLocked}
        />
      </Toolbar>
    );
  };

  render() {
    return this.state.isLoading ? (
      <PieChart />
    ) : this.props.target_list.length === 0 ? (
      <div>
        <NoChartData />
        {this.renderOptions()}
      </div>
    ) : (
      <div>
        <Container fluid>
          <Row>
            <Col>
              <GraphView
                title={this.props.chartTitle}
                parent_chart={this.chart}
                target_list={this.props.target_list}
                toView={this.state.toView}
              />
            </Col>
          </Row>
          <Row>
            <Col>{this.renderOptions()}</Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    chartTitle: state.chart_title.inventoryTarget,
    target_list: state.inventory_target.target_list,
  };
};

const mapDispatchToProps = {
  openModal: openModal,
  SetChartInventoryTargetTitle: SetChartInventoryTargetTitle,
  GetInventoryTargetOverallV4: GetInventoryTargetOverallV4,
  GetInventoryTargetAreaV4: GetInventoryTargetAreaV4,
  GetInventoryTargetClusterV4: GetInventoryTargetClusterV4,
};

InventoryBarGraph.contextType = DashboardContext;

export default connect(mapStateToProps, mapDispatchToProps)(InventoryBarGraph);
